import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Text,
    Input,
    Flex,
    Box
  } from '@chakra-ui/react'
import { useEffect } from 'react';


  function EmailModal({emailModal=null, setEmailModal=null,
    setEmailInput ="", emailInput="", emailSubmit=null}) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() =>{
        if (emailModal === true){
            onOpen()
            setEmailModal(false)
        }
        console.log("credit remind trigger")
    }
    ,[emailModal])

    const handleOnClose = () =>{
        onClose()
        setEmailModal(false)
    }

    return (
      <>
        <Modal isCentered isOpen={isOpen} onClose={handleOnClose}>
          <ModalOverlay />
          <ModalContent  color={"black"} background={'#FBBF24'} maxH="400px" maxW="100vw">
            <ModalHeader  marginLeft={["0px","0px","60px","100px"]}>Want to see More?</ModalHeader>
            <ModalCloseButton />
            <ModalBody >
              {/* <Text>You were not charged any tokens. We apologize for any inconvenience caused. As AI technology is still in its early stages of development, errors may occur from time to time. Our team is continuously working to improve the system and minimize errors. Thank you for your understanding</Text> */}
              <Flex justifyContent={"space-between"} flexDir={["column","column","row","row"]}>
              <Text marginLeft={["0px","0px","60px","100px"]}>Enter your email to be first in line for our new suite of skills based products.</Text>
            <Flex marginRight={["0","0","5%","10%"]} width={["100%","100%","30%","30%"]} >
            <Input background={"white"}
                      type={"text"} placeholder="enter your email"
                value={emailInput} onChange={event => setEmailInput(event.target.value)}
                onKeyPress={(e) => {
        if (e.key === 'Enter') {
            console.log("here")
            emailSubmit()
            onClose()
        }
        }}
            ></Input>
            <Button onClick={()=>{
                emailSubmit()
                onClose()
            }} marginLeft={"-5px"} borderRadius={0} color="white" background={"#112248"} width="30%">Continue</Button>
            </Flex>
            </Flex>
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }

  export default EmailModal;